import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private ManufacturerTypes */
import {
  Settings,
  _ManufacturerBranchOfficeSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedBranchOfficeTemplate = {
  id: 0,
  name: '',
  taxnumber: '',
  street: '',
  hnumber: '',
  city: '',
  zipcode: '',
  contry: '',
  manufacturers_id: 0
}

export default {
  namespaced: true,
  state: {
    manufacturerBranchOffices: [],
    selectedBranchOffice: _.cloneDeep(selectedBranchOfficeTemplate)
  },
  mutations: {
    [_ManufacturerBranchOfficeSettings.mutations.addNewBranchOffice] (state, payload) {
      if (state.manufacturerBranchOffices === null) {
        state.manufacturerBranchOffices = []
      }
      state.manufacturerBranchOffices.push(payload)
    },
    [_ManufacturerBranchOfficeSettings.mutations.removeBranchOffice] (state, payload) {
      state.manufacturerBranchOffices.splice(payload, 1)
    },
    [_ManufacturerBranchOfficeSettings.mutations.setBranchOffices] (state, payload) {
      state.manufacturerBranchOffices = payload
    },
    [_ManufacturerBranchOfficeSettings.mutations.setSelectedBranchOffice] (state, payload) {
      if (payload !== null) {
        state.selectedBranchOffice = payload
      } else {
        state.selectedBranchOffice = _.cloneDeep(selectedBranchOfficeTemplate)
      }
    }
  },
  actions: {
    [_ManufacturerBranchOfficeSettings.actions.addNewBranchOffice] ({ commit }, payload) {
      commit(_ManufacturerBranchOfficeSettings.mutations.addNewBranchOffice, payload)
    },
    [_ManufacturerBranchOfficeSettings.actions.setSelectedBranchOffice] ({ commit }, payload) {
      commit(_ManufacturerBranchOfficeSettings.mutations.setSelectedBranchOffice, payload)
    },
    [_ManufacturerBranchOfficeSettings.actions.removeBranchOffice] (context, payload) {
      const tempBranchOffices = context.getters.getBranchOffices
      const id = tempBranchOffices[payload].id

      if (id === 0) {
        context.commit(_ManufacturerBranchOfficeSettings.mutations.removeBranchOffice, payload)
        return
      }

      var url = API_URL + '/api/v1/manufacturerBranchOffices/' + id

      console.log('removeBranchOffice: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_ManufacturerBranchOfficeSettings.mutations.removeBranchOffice, payload)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_ManufacturerBranchOfficeSettings.actions.saveBranchOffices] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === 0) {
          var url = API_URL + '/api/v1/manufacturerBranchOffices'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/manufacturerBranchOffices/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_ManufacturerBranchOfficeSettings.actions.loadBranchOffices] (context, payload) {
      var url = API_URL + '/api/v1/manufacturerBranchOffices/manufacturer/' + payload

      console.log('loadBranchOffices: ' + payload)

      store.commit(Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_ManufacturerBranchOfficeSettings.mutations.setBranchOffices, r.data.data)
        console.log('loadBranchOffices: ' + JSON.stringify(r.data))
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_ManufacturerBranchOfficeSettings.actions.resetManufacturersBranchOffices] (context, payload) {
      context.commit(_ManufacturerBranchOfficeSettings.mutations.setBranchOffices, [])
    },
    [_ManufacturerBranchOfficeSettings.actions.resetState] (context, payload) {
      context.commit(_ManufacturerBranchOfficeSettings.mutations.setBranchOffices, [])
      context.commit(_ManufacturerBranchOfficeSettings.mutations.setSelectedBranchOffice, null)
    }
  },
  getters: {
    [_ManufacturerBranchOfficeSettings.getters.getBranchOffices] (state) {
      return state.manufacturerBranchOffices
    },
    [_ManufacturerBranchOfficeSettings.getters.getSelectedBranchOffice] (state) {
      return state.selectedBranchOffice
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/manufacturerBranchOffices.js